import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect',
  template:`Redirecting...`
})
export class RedirectComponent {
   userDetails$ : Observable<any>;
  constructor(private store: Store<any>, private router: Router) {
     this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
  }

  ngOnInit(){
   this.userDetails$.subscribe(data => {
        const landingPage = data?.landing_page;
      const fallback = '/user/record/tracker';
      if (!landingPage) {
        this.router.navigateByUrl(fallback);
        return;
      }
      try {
        const url = new URL(landingPage);
        const isAllowed = environment.allowUrl.includes(url.origin);
        const isUserPathValid = url.pathname.startsWith('/user/') && url.pathname.split('/').length > 2;
        if (isAllowed && isUserPathValid) {
          const path = url.pathname + url.search;
          this.router.navigateByUrl(path);
        } else {
          this.router.navigateByUrl(fallback);
        }
      } catch {
        this.router.navigateByUrl(fallback);
      }
    });
  }
  
}
